// import firebase from "firebase";
// eslint-disable-next-line no-undef
// const stripe = Stripe(process.env.API_PUBULISHABLEKEY);
const stripekey = process.env.VUE_APP_STRIPE_PUBLISHABLEKEY;
// eslint-disable-next-line no-undef
const stripe = Stripe(stripekey);

export { stripe };
